<template>
  <v-container fluid class="pa-0 ma-0">
    <v-tabs color="primary" v-model="activeTab" grow show-arrows>
      <v-tab v-for="(item, index) in filteredList" :key="index" color="primary">
        {{ item.Header }}
      </v-tab>
      <v-tab-item v-for="(item, index) in filteredList" :key="index">
        <v-container class="pa-0 ma-0" fluid>
          <row>
            <template v-for="(subItem, subIndex) in item.sublist">
              <v-col
                v-if="
                  (subItem.Header && subItem.Header.length > 0) ||
                  (subItem.Description && subItem.Description.length > 0)
                "
                :key="subIndex"
                cols="12"
                lg="6"
              >
                <base-contentpage-card :item="subItem" />
              </v-col>
              <v-col
                class="pa-0"
                v-if="$vuetify.breakpoint.mdAndDown"
                :key="'seperator-' + subIndex"
                cols="12"
              >
                <base-seperator :item="item" />
              </v-col>
            </template>
          </row>
        </v-container>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import BaseContentpageCard from "@/components/contentpage/base/BaseContentpageCard";
import BaseSeperator from "@/components/contentpage/base/BaseSeperator";

export default {
  components: {
    BaseContentpageCard,
    BaseSeperator,
  },
  props: {
    list: Array,
  },
  data() {
    return {
      activeTab: 0,
    };
  },
  computed: {
    // filters out indexes with empty headers or sublists from this.list
    filteredList() {
      return this.list.filter(
        (el) =>
          el.Header &&
          el.Header.length > 0 &&
          el.sublist &&
          el.sublist.length > 0 &&
          el.sublist.some(
            (sub) =>
              (sub.Header && sub.Header.length > 0) ||
              (sub.Description && sub.Description.length > 0)
          )
      );
    },
  },
};
</script>
